<div class="common-popup">
    <div class="custom-close" (click)="close()">
        <img src="../../assets/images/new-close.svg" alt="Close" />
    </div>
    <div class="select-role">
        <h4>Choose role to signup</h4>
    </div>
    <ul>
        <li *ngFor="let role of roles" [ngClass]="{ 'custom-line': role.hasLine }">
            <div class="individual-driver">
                <img [src]="role.image" [alt]="role.title" />
                <h5>{{ role.title }}</h5>
                <div class="select-btn">
                    <p-button styleClass="p-button p-button-outlined" label="Select"
                        (onClick)="routeClick(role.route)"></p-button>
                </div>
            </div>
        </li>
    </ul>
</div>